import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AIAgent from './AIAgent/aiAgent.jsx';
import AISearch from './AISearch/aiSearch.jsx';

const TAB_ROUTES = {
    '0': '/dashboard/ai-solutions',
    '1': '/dashboard/artificial-intelligence',
};

const ROUTE_TABS = {
    '/dashboard/ai-solutions': '0',
    '/dashboard/performance-ai/ask-epm': '0',
    '/dashboard/artificial-intelligence': '1',
    '/dashboard/ask-epm': '0',
};

export class AISolutionsComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tabValue: this.getTabFromPath(props.location.pathname),
        };
    }

    getTabFromPath = (pathname) => {
        return ROUTE_TABS[pathname] || '0';
    };

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({
                tabValue: this.getTabFromPath(this.props.location.pathname),
            });
        }
    }

    handleTabChange = (event) => {
        const newValue = event.target.value;

        this.setState({
            tabValue: newValue,
        }, () => {
            this.props.history.push(TAB_ROUTES[newValue]);
        });
    };

    render() {
        const { tabValue } = this.state;

        return (
            <div className='page-content'>
                <div className='tile-container flex' style={{ padding: '20px', gap: '2em' }}>
                    <FormControl component="fieldset" className='background-class'>
                        <RadioGroup
                            name="radio"
                            value={tabValue}
                            onChange={this.handleTabChange}
                            className='radioGroupHorizontal mb-20'
                        >
                            <FormControlLabel value="0" control={<Radio color="primary" />} label="AI Search" />
                            <FormControlLabel value="1" control={<Radio color="primary" />} label="AI Agent" />
                        </RadioGroup>
                    </FormControl>
                </div>
                {tabValue === '1' && <AIAgent />}
                {tabValue === '0' && <AISearch />}
            </div>
        );
    }
}

export default withRouter(connect(
    state => {
        return {
            authReducer: state.authReducer
        };
    }
)(AISolutionsComponent));
